var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('textarea',{directives:[{name:"focus",rawName:"v-focus",value:(_vm.focus),expression:"focus"}],staticClass:"form-textarea",class:{ 'form-textarea--invalid': _vm.isValid === false },domProps:{"value":_vm.value},on:{"input":function($event){return _vm.handleInput($event.target.value)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }